/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMinusCircle: {
  name: 'minus-circle';
  data: string;
} = {
  name: 'minus-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm3 11a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2h6Z" fill="currentColor"/></svg>`,
};
